import React from 'react'
import PropTypes from 'prop-types'
import { Select, MenuItem } from '@material-ui/core'
import sizingEnums from '../enums/sizings'
import styles from './SizingSelect.icss'

const getSize = (values, myIndexSize, allSizesValue) => (values.length === 1 ? values[0] : myIndexSize || allSizesValue || '')

class SizingSelect extends React.Component {
	constructor(props) {
		super(props)
		const size = {}
		let sizeArray = []
		if (props.size && props.sizing) {
			sizeArray = props.size.split('-') || []
		}
		if (props.sizing) {
			props.sizing.forEach((sizing, index) => {
				size[sizing] = sizeArray[index]
			})
		}

		this.state = { size }
		this.handleSizeChange = this.handleSizeChange.bind(this)
	}

	handleSizeChange(newSize) {
		this.setState(state => ({
			size: { ...state.size, ...newSize }
		}), () => {
			const size = this.state.size
			const mySize = Object.keys(size).map(n => size[n]).join('-')
			this.props.handleSizeChange(mySize)
		})
	}

	render() {
		const { size, handleSizeChange, allSizesValue, sizing, itemKey, ...selectProps } = this.props
		const mySizes = size ? size.split('-') : []
		return (
			<div>
				{sizing && sizing.map((mySizing, index) => {
					//	Fall back to one size when invalid size
					const sEnum = sizingEnums[mySizing] || sizingEnums.ONESIZE
					const values = sEnum.values
					const sizeText = sEnum.text
					return (
						<span key={`sizing-${mySizing}`} className={styles.selectSurround}>
							<Select
								{...selectProps}
								className={styles.selectBox}
								value={getSize(values, mySizes[index], allSizesValue)}
								disabled={values.length < 2}
								onChange={(e) => {
									const value = e.target.value
									this.handleSizeChange({ [mySizing]: value })
								}}
								inputProps={{
									name: 'size',
									id: 'size'
								}}
							>
								{allSizesValue && values.length > 1 && <MenuItem value={allSizesValue}>{this.context.translate('{sizeText}: All sizes', { sizeText })}</MenuItem>}
								{values && values.map(sizeName => (
									<MenuItem
										key={`size-${mySizing}-${this.props.itemKey}-${sizeName}`}
										value={sizeName}
									>
										{this.context.translate('{sizeText}: {sizeName}', { sizeName, sizeText })}
									</MenuItem>
								))
								}
							</Select>
						</span>
					)
				})}
			</div>
		)
	}
}

export default SizingSelect

SizingSelect.propTypes = {
	size: PropTypes.string,
	handleSizeChange: PropTypes.func,
	allSizesValue: PropTypes.string,
	itemKey: PropTypes.string,
	sizing: PropTypes.array // eslint-disable-line react/forbid-prop-types
}

SizingSelect.defaultProps = {
	size: undefined,
	allSizesValue: undefined,
	itemKey: undefined,
	handleSizeChange: () => null,
	sizing: undefined
}

SizingSelect.contextTypes = {
	translate: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/SizingSelect.jsx